import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { cssVariables } from '@env/css-vars';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { MUNICIPALITYMANAGEMENT } from '../models/municipality-management.constants';

@Injectable({
  providedIn: 'root',
})
export class MunicipalityManagementDialogHelperService {
  private readonly mainModule = MUNICIPALITYMANAGEMENT.MODULE.MAIN;
  private readonly generalInfo = MUNICIPALITYMANAGEMENT.MODULE.GENERAL_INFO;

  constructor(private matDialog: MatDialog, private translateService: TranslateService) {}

  public saveConfirmation(): Observable<number> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptText'),
          confirmText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptOkButtonText'),
          declineText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptCancelButtonText'),
        },
        panelClass: ['-md'],
      })
      .afterClosed()
      .pipe(map((res: boolean) => (res ? 1 : 0)));
  }

  public saveConfirmationError(): Observable<number> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          title: this.translateService.instant(this.mainModule + this.generalInfo + 'inputErrorPromptTitle'),
          descriptionText: this.translateService.instant(this.mainModule + this.generalInfo + 'inputErrorPromptText'),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--error-color'],
          confirmText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptOkButtonText'),
        },
      })
      .afterClosed()
      .pipe(map(() => 2));
  }

  public saveSuccess(): void {
    this.matDialog.open(NotificationDialogComponent, {
      data: {
        descriptionText: this.translateService.instant(this.mainModule + this.generalInfo + 'updateSuccessText'),
        descriptionFaClass: 'fa-check-circle fa-2x',
        descriptionFaColor: cssVariables['--success-color'],
        hideClose: false,
        confirmText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptOkButtonText'),
      },
      panelClass: ['-sm'],
    });
  }

  public saveError(): void {
    this.matDialog.open(NotificationDialogComponent, {
      data: {
        descriptionText: this.translateService.instant(this.mainModule + 'saveErrorText'),
        descriptionFaClass: `fa-triangle fa-2x`,
        descriptionFaColor: cssVariables['--error-color'],
        hideClose: false,
        confirmText: this.translateService.instant(this.mainModule + this.generalInfo + 'confirmSavePromptOkButtonText'),
      },
      panelClass: ['-sm'],
    });
  }

  public testDataConfirmation(): Observable<any> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          title: this.translateService.instant(this.mainModule + 'deleteTestData.deleteTestDataModalTitle'),
          descriptionText: this.translateService.instant(this.mainModule + 'deleteTestData.deleteTestDataModalInstructionText'),
          confirmText: this.translateService.instant(this.mainModule + 'deleteTestData.confirmDeleteDataButtonText'),
          declineText: this.translateService.instant(this.mainModule + 'deleteTestData.cancelDeleteDataButtonText'),
        },
        panelClass: ['-md'],
      })
      .afterClosed();
  }

  public testDataErrorNotTestMunicipality(): Observable<any> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translateService.instant(this.mainModule + 'deleteTestData.unableToDeleteMunicipalityNotTestingMessage'),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--ep-error-color'],
        },
        position: { top: '40px' },
        panelClass: ['-md'],
      })
      .afterClosed();
  }

  public testDataErrorGeneral(): Observable<any> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translateService.instant(this.mainModule + 'deleteTestData.unableToDeleteMunicipality'),
          descriptionFaClass: 'fa-exclamation-triangle fa-2x',
          descriptionFaColor: cssVariables['--ep-error-color'],
        },
        position: { top: '40px' },
        panelClass: ['-md'],
      })
      .afterClosed();
  }

  public testDataSuccess(): Observable<any> {
    return this.matDialog
      .open(NotificationDialogComponent, {
        data: {
          descriptionText: this.translateService.instant(this.mainModule + 'deleteTestData.testDataDeletedText'),
          descriptionFaClass: 'fa-info-circle fa-2x',
        },
        position: { top: '40px' },
        panelClass: ['-md'],
      })
      .afterClosed();
  }
}
